export default {
  data(){
    return{
      zoneImgURL:require('../assets/default-zone-image.jpg')
    }
  },
};